<template>

     
  <div class="  row color_light" style=" " >
      <!-- <div v-for="content in boxdata"  v-bind:key="content"> -->
      <div class="col-md-8" style="padding:3px 3px ">
     

       <div>{{$t('packingb2b.packingBoxId') }}:  <span class="textcolor">  {{boxdata.boxid}} </span> </div>
      <div>{{$t('orders.totalQTY') }}: <span class="textcolor">  {{boxdata.qty}}</span> </div>
        <div>{{$t('boxList.boxWeight')}}:<span class="textcolor">  {{boxdata.weight}}</span>  </div>
         <div>{{ $t('packingb2b.boxDimension')}}:<span class="textcolor">  {{boxdata.lbh}}</span> </div>
       </div>
         
        <div class=" col-md-4" style="padding:3px 0px ">
       
     
        <button
          type="button"
          class="btn btn-primary shipinvoice"
          style="width: 100% ;margin-bottom:5px"
          v-on:click="selectType(1)"
        >
          {{ $t('packingb2b.shipLabel') }}
        </button>
     
        <button
          type="button"
          class="btn btn-primary shipinvoice"
          style="width: 100% ;float:right"
          v-on:click="selectType(0)"
        >
        {{$t('packingb2b.packingList') }}
        </button>
       
      </div>
       
      <!-- </div> -->
    <div class="col-md-12 mb-1">
        </div>

         <b-modal v-model="modalShowForConfirmType" id=confirmationmodal  title="Confirmation" data-backdrop="static"  >
            <div role="document">
              <div class="modal-content">
                <div class="modal-headerfrm">
                  <h6 class="modal-title">{{$t('packingb2b.printPackingSlip') }}</h6>
                  <button type="button" class="close" @click="modalShowForConfirm" data-dismiss="confirmationmodal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-bodyfrm">
                  <input type="radio" id="paper"  name="pickingtype" value="paper" v-model="papertype" class="col-lg-1">
                  <label for="cluster">{{$t('packingb2b.paper') }}</label>
                  <input type="radio" id="sticker"  name="pickingtype" value="sticker" v-model="papertype" class="col-lg-1">
                  <label for="batch">{{$t('packingb2b.sticker') }}</label>
                  <div class="form-group row">
                    <div class="col-md-12" >
                      <div class="float-right">
                  <button type="button" v-on:click="downloadShipLabel"  class="btn btn-success">{{ $t('common.print') }}</button>
                  <button type="button" class="btn btn-danger" @click="modalShowForConfirm" ><i class="fa fa-ban"></i>{{ $t('common.cancelBtn') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
          </b-modal>
  </div>

    </template>
   
    <script>
    import apiUrl from '../../constants';
import axios from 'axios';
import LoginVue from '../pages/Login.vue';
import Vue from 'vue';
    export default {
        name:'SingleBox',
        components:{},
        props:['boxdata','clientid','disableflag'],
     
       

        data:function(){
            return{
                modalShowForConfirmType:false,
                invoiceType:"label",
                papertype:"",
                modalShowForConfirmType:false,
                papertype:"paper",
                invoiceType:"label",
            }

        },
        mounted(){
          if(this.disableflag)
        { let buttons= document.getElementsByClassName('shipinvoice')
                for(var i=0; i< buttons.length; i++){
                  buttons[i].disabled = true;						
                }
        }
        },
         
           watch: { 
      	disableflag: function(newVal, oldVal) { // watch it
  console.log(newVal,"newVal")
  if(newVal)
       {let buttons= document.getElementsByClassName('shipinvoice')
			for(var i=0; i< buttons.length; i++){
				buttons[i].disabled = true;						
			}
            }  else{
 let buttons= document.getElementsByClassName('shipinvoice')
			for(var i=0; i< buttons.length; i++){
				buttons[i].disabled = false;						
			}
              }
        }
      },
        methods:{
        selectType(type){
        console.log("erherherhehrhreh");
        this.modalShowForConfirmType=true;
        document.getElementById( 'confirmationmodal' ).style.display = 'block';

        if(type)
        this.invoiceType="label"
        else
        this.invoiceType="slip"
        },
            async downloadShipLabel(){
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        let result
        let payload= {
                  
        "clientid":this.clientid,
        "boxids":[this.boxdata.boxid],
        "pageformat": this.papertype=="paper"?"A4":"",
        "barcodeformat": ""

  }

let type=""
if(this.invoiceType=="label"){
   type="label"

            result=await axios({
method: 'POST',
'url': apiUrl.api_url + 'generateShipLabel',
'data': payload,
headers: {
'Authorization': 'Bearer ' + myStr,

},

responseType: 'blob'
})
    }
else{
  type="invoice"
payload= {
           
"clientid":window.localStorage.getItem('selectedClient'),
           "boxids":[this.boxdata.boxid],
           "format": this.papertype=="paper"?"A4":""

  }
result=await axios({
method: 'POST',
'url': apiUrl.api_url + 'generatePackingSlip',
'data': payload,
headers: {
'Authorization': 'Bearer ' + myStr,

},

responseType: 'blob'
})
}

let file = window.URL.createObjectURL(result.data);
const a = document.createElement("a");
a.href = file;
a.download =  ""+type+"_"+this.boxdata.boxid;
document.body.appendChild(a);
a.click();

window.onfocus = function () {                    
 document.body.removeChild(a)
}
},
    modalShowForConfirm(){
console.log("tttt");
this.modalShowForConfirmType=false;

Vue.nextTick(() => {
      document.getElementById( 'confirmationmodal' ).style.display = 'none';
      document.getElementById( 'packingscreenmodel' ).style.display = 'block';})




},

   

        }
    }
// e9e6e6
    </script>
   
    <style>
      .color_light{
        background-color:#dcecf3;
            margin:0rem 0.3rem;
        border: 2px solid #c7ece2;
        border-radius: 5px;
        box-shadow: 0px 4px 4px rgba(148, 150, 151, 0.747);
        padding: 5px 0px;
    }
    .textcolor{
        color:black;
        font-weight: bold;
        font-family: 'Courier New', Courier, monospace;
        text-align: center;
        }
       
    </style>


// WEBPACK FOOTER //
// src/views/common_components/singlepackingbox.vue?9af51fae